/**
 * @desc 时间戳转时间格式
 * @param {String} date 时间戳
 * @returns {String} 时间日期格式
 */
export const formatDayTimeToSimple = function (date) {
    let d = new Date(date);
    const year = d.getFullYear()
    const month = d.getMonth() + 1
    const day = d.getDate()
    return formatNumber(year) + '年' + formatNumber(month) + '月' + formatNumber(day) + '日'
}

/**
 *
 * @param {String} n 数字
 * @returns {String} 数字不足10前一位取0
 */
const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : `0${n}`
}


/**
 * @desc 时间戳转时间格式
 * @param {String} date 时间戳
 * @returns {String} hh:mm格式
 */
export const formatDayTimeToHHMM = function (date) {
    let d = new Date(date);
    const hour = d.getHours()
    const min = d.getMinutes()
    return formatNumber(hour) + ':' + formatNumber(min)
}

/**
 * 计算两个时间差
 */
export function timeDifference(date1, date2) {
    var diff = Math.abs((date2 ) - ((new Date(date1).getTime()))); // 差值，单位为毫秒
    var hours = Math.floor(diff / 3600000); // 计算小时数
    diff -= hours * 3600000;
    var minutes = Math.floor(diff / 60000); // 计算分钟数
    diff -= minutes * 60000;
    var seconds = Math.floor(diff / 1000); // 计算秒数

    return hours + "小时" + minutes + "分钟" + seconds + "秒";
}

export function checkIsPc () {
    // 更全面的移动设备User Agent识别，添加鸿蒙设备标识
    const mobileRegex = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|CriOS|FxiOS|OPiOS|mercury|OpenHarmony|MicroMessenger/i
    const isMobileUA = mobileRegex.test(navigator.userAgent)

    // 屏幕宽度判断（辅助）
    const screenWidth = window.screen.width
    const isSmallScreen = screenWidth < 768

    // 组合判断：如果是移动UA或小屏幕，都视为非PC
    return !(isMobileUA || isSmallScreen)
}
